var STOCK_STATUS_VARIANT_NAME = "Sellable"; // The name of the variant attribute that has holds the stock status
var TAG_VARIANT_NAME = "Tag";
var IN_STORE_TAG_NAME = "AVAILBLEINSTORE"; // if exist product is available in store
var ONLINE_TAG_NAME = "AVAILABLEONLINE"; // if exist product is available in online
  
/**
 * isp_slickSetup - hold the setup for each recommendation slick element
 *
 * @type: JSON
 */
const isp_slickSetup_base = {
    lazyLoad: 	'ondemand',
    dots: 		false,
    infinite: 	true,
    arrows: true,
    prevArrow: '<button type="button" class="isp-widget-arrow prev"></button>',
    nextArrow: '<button type="button" class="isp-widget-arrow next"</button>',
    speed: 400,
    slidesToShow: 4,
    slidesToScroll: 3,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,          	
        }
    }, {
        breakpoint: 800,
        settings: {
            slidesToShow: 2,
          	slidesToScroll: 2,
        }
    }, {
        breakpoint: 370,
        settings: {
            slidesToShow: 1,
          	slidesToScroll: 1,
        }
    }, {
        breakpoint: 300,
        settings: "unslick" // destroys slick
    }]
};

const isp_slickSetup = {
    "Fun stuff you may also love": {
        ...isp_slickSetup_base,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
      			slidesToScroll: 3,
            }
        }, {
            breakpoint: 800,
            settings: {
                slidesToShow: 2,
          		slidesToScroll: 2,
            }
        }, {
            breakpoint: 370,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }, {
            breakpoint: 300,
            settings: "unslick" // destroys slick
        }]
    },
    "Recently viewed items": {
        ...isp_slickSetup_base,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 4,
              	slidesToScroll: 4,
            }
        }, {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
              	slidesToScroll: 2,
            }
        }, {
            breakpoint: 370,
            settings: {
                slidesToShow: 1,
              	slidesToScroll: 1,
            }
        }, {
            breakpoint: 300,
            settings: "unslick" // destroys slick
        }]
    },
    "What’s new and now!":{
        ...isp_slickSetup_base,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
            }
        }, {
            breakpoint: 800,
            settings: {
                slidesToShow: 2,
              	slidesToScroll: 2,
            }
        }, {
            breakpoint: 370,
            settings: {
                slidesToShow: 1,
              	slidesToScroll: 1,
            }
        }, {
            breakpoint: 300,
            settings: "unslick" // destroys slick
        }]
    },
    "default" : {
        ...isp_slickSetup_base,
    }
};

// related options are in charge of the recommendation widget customization
var isp_related_options = {
    with_product_attributes: true, // add attributes to the request to get access to product tags (default is false)
    /**
     * Handle the response of the recommendation request (REST API)
     *
     * @param response JSON Object
     */
    custom_related_products_render: response => {
        response.widget_responses.forEach((widgetData, index) => {
            const {products, title} = widgetData;
            const widgetID = `#isp-related-widget-${index+1}`;
            $jquery_isp(widgetID).append(getWidgetHtml(products, title));
            $jquery_isp(`${widgetID} .isp_custom_product_carousel`).slick(isp_slickSetup[title] || isp_slickSetup["default"]);
        });

        // Legacy (get rid of containers)
      /*
        $jquery_isp(".recently-view-products .sixteen.columns").attr("class","");
        $jquery_isp(".recently-view-products .container").attr("class","");
        $jquery_isp('.recently-view-products').attr("class","");
        $jquery_isp(".related-products .sixteen.columns").attr("class","");
        $jquery_isp(".related-products .container").attr("class","");
        $jquery_isp('.related-products').attr("class","");
        */
    }
};

/**
 * Create Widget HTML
 *
 * @param products - the product from the recommendation response
 * @param title - the name of the widget
 * @returns {String} (HTML)
 */
const getWidgetHtml = (products, title) => {
    let retHtml = `<div id="custom-recommendations-widget" class="isp-recommendations-widget">`;
    retHtml += `<h3 class="isp-recommendations-title">${title}</h3>`;
    retHtml += getProductCarousel(products);
    retHtml += '<div>';

    return retHtml;
};

/**
 * Create HTML for the product carousel
 *
 * @param products - the product from the recommendation response
 * @returns {String} (HTML)
 */
const getProductCarousel = (products) => {
    let carouselHTML = '<div class="isp_custom_product_carousel" >';
    products.forEach(product => {  
      
        // badge HTML
        const badgeCount = product.b ? product.b.length : 0;
        carouselHTML += `<div class="isp-custom-product-card" productID="${product.id}" badge-count="${badgeCount}">`;
        carouselHTML += `<div class="isp-product-top-bar">`;
        carouselHTML += `<div class="isp-badge-container">`;
        if(product.b){
            product.b.forEach(badge => {
                carouselHTML += `<span class="isp_badge" type="${badgeList[badge].toLowerCase()}">${badgeList[badge]}</span>`;
            });
        }
        carouselHTML += `</div>`; // close isp-badge-container

        // Favorite Button HTML
        const productFirstVariant = product.vra && product.vra.length > 0 ? product.vra[0][0] : product.id;
        const productHandle = product.u;
        const storeUrl = window.location.origin;
        const canonicalUrl = storeUrl + productHandle;
        carouselHTML += `<button data-with-epi="true" data-swaction="addToWishlist" class="swym-button swym-add-to-wishlist-view-product product_${product.id}" data-with-epi="true" data-product-id="${product.id}" data-product-url="${canonicalUrl}" data-variant-id="${productFirstVariant}"></button>`;
        carouselHTML += `</div>`; // isp-product-top-bar

        //Product image HTML
        carouselHTML += `<a class="isp-product-card-image-container" href="${product.u}">`;
        carouselHTML += `<img class="isp-product-card-image" src="${product.t}" alt="product image">`;
        carouselHTML += `</a>`;

        //Product info HTML
        carouselHTML += '<div class="isp-product-card-info">';
        carouselHTML += `<a class="isp-product-title-container"  href="${product.u}">`;
        carouselHTML += `<div class="isp-product-card-title">${product.l}</div>`;
        carouselHTML += `</a>`;
        
        if (product.p_c > 0){
          carouselHTML += `<div class="isp_product_price_wrapper">`;
          carouselHTML += `<div class="isp_compare_at_price">$${product.p_c}</div>`;
          carouselHTML += `<div class="isp_product_price">$${product.p}</div>`;
          carouselHTML += `</div>`;            	        
        }
        else
        {
          carouselHTML += `<div class="isp_product_price_wrapper">`;        
          carouselHTML += `<div class="isp_product_price">$${product.p}</div>`;
          carouselHTML += `</div>`;  
        }
                  
      	// add reviews
        if (product.reviews_count) {
          	var stars = product.review / 20;
      		var starImage;
      		var reviews = product.review;
      		
          carouselHTML += '<div class="isp_product_rec_review" style="display: flex;" title="Average Score: ' + stars + ' | Total reviews: ' + product.reviews_count + '" role="img">';
          	
          for (var i = 1; i <= 5; i++) {
            if (reviews <= 0) {
              carouselHTML += '<img src=https://acp-magento.appspot.com/images/rating-empty.png title="empty"/>';
              reviews = reviews - 20;

            } else if (reviews % 20 === 0) {
              carouselHTML += '<img src=https://cdn1-gae-ssl-default.akamaized.net/images/rating-full.png title="full"/>';
              reviews = reviews - 20;

            } else {
              carouselHTML += '<img src=https://acp-magento.appspot.com/images/rating-half.png title="half"/>';
              reviews = reviews - (reviews % 20);            
            }
          }
          
          carouselHTML += '<span class="isp_product_rec_reviews_count">(' + product.reviews_count + ')</span></div>';
        }

        //Product Add to Cart HTML
        carouselHTML += AddtoCartHTMLRecommendations(product);
        carouselHTML += '</div></div>'; //  Close info, close product tile
    });
    carouselHTML += '</div>'; // close carousel

    return carouselHTML;
};


const AddtoCartHTMLRecommendations = (product) => {  	
  	const prodid = product.id;
    const prodvid = product.vra[0][0];    
  
    let retHTML = `<form id="form_${prodid}" onsubmit="isp_on_submit_store(${prodid}, 11, 'form_${prodid}', event)" class="isp_add_to_cart_form" action="/cart/add" method="post"><input name="id" type="hidden" value="${prodvid}"><input type="submit" value="Add to Cart" name="button" class="isp_add_to_cart_btn">`;
    return  retHTML + '</form>'
};

